var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{staticClass:"TopicStaticPage"},[_c('IllustrationBanner'),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('TopicStaticContent')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }